/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'

import { Button, Grid, Tooltip, Typography } from '@material-ui/core'
import { Download as DownloadIcon } from 'react-feather'

import { Card, LoadingFeedback } from 'components'

import useIncidentManegement from 'hooks/useIncidentManegement'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import formatters from 'helpers/formatters'
import constants from 'constants/index'

const ReportStep = () => {
  const [loading, setLoading] = useState(false)
  const [exportingPdf, setExportingPdf] = useState(false)
  const { wantsToAdvanceStep, handleNext, resetAdvanceStep, incident, isShow } =
    useIncidentManegement()
  const snackbar = useSnackbar()

  const handleOpenNotificationDocument = async () =>
    window.open(incident?.notificationOpinionAttachment?.url, '_blank')

  const onSubmit = async () => {
    if (isShow) {
      resetAdvanceStep()
      handleNext()
      return
    }

    setLoading(true)

    try {
      await service.dponet.incidents.concludeStep({
        incidentId: incident.id,
        step: constants.incidentManegement.REPORTING_ENUM,
      })

      resetAdvanceStep()
      handleNext()
    } catch (error) {
      snackbar.open({
        message: formatters.errorMessage(error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
      resetAdvanceStep()
    }
  }

  const generateReport = async (simplifiedForm) => {
    setExportingPdf(true)
    try {
      await service.dponet.incidents.exportReport({
        incidentId: incident.id,
        simplifiedForm,
        shouldCreateVersion: false,
      })

      snackbar.open({
        message: 'O relatório será gerado e enviado por e-mail!',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          formatters.errorMessage(error) ||
          'Ocorreu um erro ao gerar o relatório',
        variant: 'error',
      })
    } finally {
      setExportingPdf(false)
    }
  }

  const handleGenerateSimplifiedIncidentReport = () => generateReport('true')

  const handleGenerateCompleteIncidentReport = () => generateReport('false')

  useEffect(() => {
    if (wantsToAdvanceStep) {
      onSubmit()
    }
  }, [wantsToAdvanceStep])

  return (
    <Grid
      container
      spacing={1}
      id={constants.incidents.INCIDENT_MAIN_DRIVER_STEP_9}
    >
      <LoadingFeedback open={loading || exportingPdf} />

      <Grid item xs={12}>
        <Card title="Relatório Simplificado">
          <Typography variant="body1" gutterBottom>
            Faça o download do relatório simplificado para ter uma visão geral
            do incidente. Este relatório não é válido para comunicação à ANPD. O
            relatório será enviado para o seu e-mail.
          </Typography>

          <Button
            startIcon={<DownloadIcon size={16} />}
            variant="outlined"
            onClick={handleGenerateSimplifiedIncidentReport}
          >
            Relatório Simplificado
          </Button>
        </Card>
      </Grid>
      {!incident?.simplifiedForm && (
        <Grid item xs={12}>
          <Card title="Relatório Completo">
            <Typography variant="body1" gutterBottom>
              É necessário fazer o download do relatório completo para anexá-lo
              à comunicação aos titulares de dados e à ANPD. O relatório será
              enviado para o seu e-mail.
            </Typography>

            <Tooltip
              title={
                incident?.riskAssumed
                  ? 'Relatório indisponível enquanto o risco estiver assumido.'
                  : ''
              }
            >
              <span>
                <Button
                  startIcon={<DownloadIcon size={16} />}
                  variant="outlined"
                  disabled={incident?.riskAssumed}
                  onClick={handleGenerateCompleteIncidentReport}
                >
                  Relatório Completo
                </Button>
              </span>
            </Tooltip>
          </Card>
        </Grid>
      )}
      {incident?.notificationOpinionAttachment?.url && (
        <Grid item xs={12}>
          <Card title="Documento para comunicação de titulares de dados">
            <Typography variant="body1" gutterBottom>
              É necessário fazer o download do documento para que possa enviar
              aos titulares de dados.
            </Typography>

            <Button
              startIcon={<DownloadIcon size={16} />}
              variant="outlined"
              onClick={handleOpenNotificationDocument}
            >
              Documento
            </Button>
          </Card>
        </Grid>
      )}
    </Grid>
  )
}

export default ReportStep
